module.exports = __webpack_public_path__ + "media/assets/blog_banner-fe4276b30f347602aa45049cdb690110.jpg";